import { AsyncSelect, Button, MultiSelectDropDown, SelectDropDown } from '@wot/components';
import { Strengths } from '@wot/shared';
import {
  ILevels,
  IProfessionHobby,
  IProfessionHobbyType,
  IProfessionSkill,
  IProfessionSubject,
  ITutorProfessionCategory
} from '@wot/typings';
import { useEffect, useState } from 'react';
import categoriesApi from '../../../../api/categories';
import { CLOSE_ICON } from '../../../../assets/icons';
import { toast } from 'react-toastify';

const expOptions = ["1", "2", "3", "4", "5", "more than 5 years"];

const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

interface Props {
  category: 'hobby' | 'skill';
  categories: ITutorProfessionCategory<IProfessionHobby>[];
  handleChange?: (data: ITutorProfessionCategory<IProfessionSubject | IProfessionHobby | IProfessionSkill>[]) => void;
}

export default function AddHobby({ category, categories, handleChange }: Props) {
  const [tempSubjects, setTempSubjects] = useState<ITutorProfessionCategory<IProfessionHobby>[]>(categories || []);

  // let filter = Object.assign(
  //   {},
  //   { page: currentPage },
  //   { resultsPerPage },
  //   categorySelected && { category: categorySelected },
  //   subList.length > 0 && { categoryName: subList },
  //   gradeList.length > 0 && { grades: gradeList },
  //   boardList.length > 0 && { boards: boardList },
  //   typeList.length > 0 && { categoryTypeName: typeList },
  //   levelList.length > 0 && { levels: levelList },
  //   quality && { quality }
  // );

  const handleFormChange = (newValues: ITutorProfessionCategory<IProfessionHobby>, index?: number, remove?: number) => {
    let val = Object.assign(
      {},
      { name: newValues.name },
      newValues.levels &&
      newValues.levels.length && {
        levels: newValues.levels
      },
      newValues.types &&
      newValues.types.length && {
        types: newValues.types
      },
      newValues.experience && { experience: newValues.experience },
      newValues.strengths &&
      newValues.strengths.length && {
        strengths: newValues.strengths
      }
    );
    let temp = [...tempSubjects];
    if (index) {
      if (remove) {
        temp = temp.filter((item, idx) => idx !== index - 1);
        setTempSubjects(temp);
        return;
      }
      let stemp = temp.filter((_, i) => i !== index - 1);
      let exists = stemp.filter((s) => s.name == newValues.name).length > 0;
      if (exists) {
        toast.error(`${newValues.name} ${category} already added`)
        return true;
      }
      temp[index - 1] = val;
      setTempSubjects(temp);
    } else {
      let exists = temp.filter((s) => s.name == newValues.name).length > 0;
      if (exists) {
        toast.error(`${newValues.name} ${category} already added`)
        return true;
      }
      temp.push(val);
      setTempSubjects(temp);
    }
  };

  useEffect(() => {
    handleChange && handleChange(tempSubjects);
  }, [tempSubjects]);

  return (
    <div className=" w-full h-full flex flex-col md:px-6 bg-white overflow-y-scroll custom-scrollbar pb-40">
      <CurrentForm handleFormChange={handleFormChange} category={category} />
      <div className="flex flex-col gap-5">
        {tempSubjects.map((subject, index) => (
          <HobbyItem
            category={category}
            hobby={subject}
            handleFormChange={handleFormChange}
            index={index + 1}
            key={index + 1}
          />
        ))}
      </div>
    </div>
  );
}

function CurrentForm({
  category,
  handleFormChange
}: {
  category: 'hobby' | 'skill';
  handleFormChange: (v: ITutorProfessionCategory<IProfessionHobby>, index?: number) => void;
}) {
  const [currentHobby, setCurrentHobby] = useState<ITutorProfessionCategory<IProfessionHobby>>({
    name: '',
    levels: [],
    strengths: [],
    types: [],
    experience: ""
  });

  const [errors, setErrors] = useState<HobbyFormError>();
  const [showNewForm, setShowNewForm] = useState<boolean>(false);

  return (
    <div className="w-full flex flex-col my-5 gap-2">
      <div className="w-full flex items-center justify-between">
        <h1 className="text-xl font-semibold">{capitalizeFirstLetter(category)}</h1>
        <div className="max-w-xs">
          {!showNewForm && (
            <Button
              text={`+ Add New ${capitalizeFirstLetter(category)}`}
              onClick={() => {
                setShowNewForm(true);
                // if (
                //   !currentHobby.name ||
                //   (currentHobby.types?.length === 0 &&
                //     !currentHobby.levels?.length &&
                //     !currentHobby.strengths?.length) ||
                //   (currentHobby.experience && currentHobby.experience <= 0) ||
                //   (currentHobby.levels?.length === 0 &&
                //     !currentHobby.types?.length)
                // ) {
                //   setErrors({
                //     name: !currentHobby.name,
                //     levels:
                //       currentHobby.types?.length === 0 &&
                //       !currentHobby.levels?.length,
                //     strengths:
                //       currentHobby.strengths?.length === 0 &&
                //       !currentHobby.levels?.length,
                //     experience:
                //       currentHobby.experience! <= 0 &&
                //       !currentHobby.levels?.length,
                //     types:
                //       currentHobby.levels?.length === 0 &&
                //       !currentHobby.types?.length,
                //   });
                //   return;
                // }
                // setErrors(undefined);
                // handleFormChange(currentHobby);
                // setCurrentHobby({
                //   name: "",
                //   levels: [],
                //   strengths: [],
                //   experience: 0,
                //   types: [],
                // });
              }}
            />
          )}
        </div>
      </div>
      {showNewForm && (
        <div className="w-full flex my-5 gap-7 p-4 border border-gray-300 rounded-md">
          <div className="w-full">
            <div className="flex w-full gap-4">
              <HobbyForm
                category={category}
                name={currentHobby.name}
                setName={(value) => setCurrentHobby({ ...currentHobby, name: value })}
                levelsList={currentHobby.levels}
                setLevelsList={(list) => setCurrentHobby({ ...currentHobby, levels: list })}
                experience={currentHobby.experience}
                setExperience={(value) => setCurrentHobby({ ...currentHobby, experience: value })}
                strengths={currentHobby.strengths}
                setStrengths={(values) => setCurrentHobby({ ...currentHobby, strengths: values })}
                types={currentHobby.types!}
                setTypes={(types) => setCurrentHobby({ ...currentHobby, types: types })}
                errors={errors}
              />
              <div className="cursor-pointer max-w-xs">
                <img
                  src={CLOSE_ICON}
                  onClick={() => {
                    setShowNewForm(false);
                    setCurrentHobby({
                      name: '',
                      levels: [],
                      types: [],
                      experience: "",
                      strengths: []
                    });
                    setErrors({});
                  }}
                />
              </div>
            </div>
            <div className="max-w-[164px] mx-auto mt-5 flex items-center justify-end">
              <Button
                block
                text="Add"
                onClick={() => {
                  if (
                    !currentHobby.name ||
                    (currentHobby.types?.length === 0 &&
                      !currentHobby.levels?.length &&
                      !currentHobby.strengths?.length) ||
                    (!currentHobby.experience) ||
                    (currentHobby.levels?.length === 0 && !currentHobby.types?.length)
                  ) {
                    setErrors({
                      name: !currentHobby.name,
                      levels: currentHobby.types?.length === 0 && !currentHobby.levels?.length,
                      strengths: currentHobby.strengths?.length === 0 && !currentHobby.levels?.length,
                      experience: !currentHobby.experience && !currentHobby.levels?.length,
                      types: currentHobby.levels?.length === 0 && !currentHobby.types?.length
                    });
                    return;
                  }
                  setErrors(undefined);
                  handleFormChange(currentHobby);
                  setCurrentHobby({
                    name: '',
                    levels: [],
                    strengths: [],
                    experience: "",
                    types: []
                  });
                  setShowNewForm(false);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

interface FormProps {
  category: 'hobby' | 'skill';
  hobby: ITutorProfessionCategory<IProfessionHobby>;
  handleFormChange: (v: ITutorProfessionCategory<IProfessionHobby>, index?: number, remove?: number) => void;
  index?: number;
}
function HobbyItem({ category, hobby, handleFormChange, index }: FormProps) {
  const [errors, setErrors] = useState<HobbyFormError>();

  useEffect(() => {
    if (
      !hobby.name ||
      (hobby.types?.length === 0 && !hobby.levels?.length) ||
      !hobby.strengths?.length ||
      !hobby.experience ||
      (hobby.levels?.length === 0 && !hobby.types?.length)
    ) {
      setErrors({
        name: !hobby.name,
        levels: hobby.types?.length === 0 && !hobby.levels?.length,
        strengths: hobby.strengths?.length === 0,
        experience: !hobby.experience,
        types: hobby.levels?.length === 0 && !hobby.types?.length
      });
      return;
    } else {
      setErrors(undefined);
    }
  }, [hobby]);

  return (
    <div className="w-full flex flex-col items-start gap-5 p-4 border border-gray-300 rounded-md">
      <img
        src={CLOSE_ICON}
        className="w-3 cursor-pointer flex ml-auto"
        onClick={() => handleFormChange(hobby, index, 1)}
      />
      <HobbyForm
        category={category}
        name={hobby.name}
        setName={(value) => handleFormChange({ ...hobby, name: value }, index)}
        levelsList={hobby.levels}
        setLevelsList={(list) => handleFormChange({ ...hobby, levels: list }, index)}
        experience={hobby.experience}
        setExperience={(value) => handleFormChange({ ...hobby, experience: value }, index)}
        strengths={hobby.strengths}
        setStrengths={(values) => handleFormChange({ ...hobby, strengths: values }, index)}
        types={hobby.types || []}
        setTypes={(types) => handleFormChange({ ...hobby, types: types }, index)}
        errors={errors}
      />
    </div>
  );
}

interface HobbyFormError {
  name?: boolean;
  levels?: boolean;
  types?: boolean;
  strengths?: boolean;
  experience?: boolean;
}

interface HobbyFormProps {
  category: 'hobby' | 'skill';
  name: string;
  setName: (value: string) => void;
  levelsList?: ILevels[];
  setLevelsList: (levels: ILevels[]) => void;
  types: IProfessionHobbyType[];
  setTypes: (types: IProfessionHobbyType[]) => void;
  experience?: string;
  strengths?: string[];
  setExperience: (value: string) => void;
  setStrengths: (strengths: string[]) => void;
  errors?: HobbyFormError;
}

export function HobbyForm({
  category,
  name,
  setName,
  levelsList,
  setLevelsList,
  types,
  setTypes,
  experience,
  setExperience,
  strengths,
  setStrengths,
  errors
}: HobbyFormProps) {
  const [isType, setIsType] = useState<boolean>(types && types.length > 0 ? true : false);

  const [hobbyOptions, setHobbyOptions] = useState<any[]>([]);
  const [levelOptions, setLevelOptions] = useState<any[]>([]);
  const [typeOptions, setTypeOptions] = useState<any[]>([]);

  useEffect(() => {
    categoriesApi.getCategoriesByType(category).then((data) => {
      setHobbyOptions(data);
    });
  }, []);

  useEffect(() => {
    if (name) {
      const currentSubject = hobbyOptions.find((item: any) => item?.category?.name === name);
      setLevelOptions(currentSubject?.category?.levels);
      setTypeOptions(currentSubject?.category?.types);
    }
  }, [name, hobbyOptions]);

  const handleTypeChange = (newValues: IProfessionHobbyType, index?: number, remove?: number) => {
    let temp = [...types];
    if (index) {
      if (remove) {
        temp = temp.filter((item, idx) => idx !== index - 1);
        setTypes(temp);
        return;
      }
      temp[index - 1] = newValues;
      setTypes(temp);
    } else {
      temp.push(newValues);
      setTypes(temp);
    }
  };
  useEffect(() => {
    if (typeOptions && typeOptions.length > 0) {
      setIsType(true);
    } else {
      setIsType(false);
    }
  }, [typeOptions]);

  return (
    <div className="w-full flex flex-col my-5 gap-4">
      <div className="flex items-center justify-between">
        <h3 className="w-2/5 text-sm shrink-0">{`${capitalizeFirstLetter(category)} Name`}</h3>
        <div className="w-full flex flex-col">
          <AsyncSelect
            placeholder={`Select ${capitalizeFirstLetter(category)}`}
            onChange={(value) => setName(value)}
            callback={async () => {
              const cats = await categoriesApi.getCategoriesByType(category);
              return cats.map((c: any) => c.category.name);
            }}
            value={name}
            isSearchable
          />
          {errors && errors.name && (
            <p className="text-xs font-medium text-red-400">
              {`Please Select ${capitalizeFirstLetter(category)} Name`}
            </p>
          )}
        </div>
      </div>
      {!isType && (
        <div className="flex flex-col gap-4">
          <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
            <h3 className="w-2/5 text-sm shrink-0">Levels</h3>
            <div className="w-full flex flex-col">
              <div className="w-full h-full">
                <MultiSelectDropDown
                  placeholder="Add Levels"
                  onChange={(values: any) => setLevelsList(values)}
                  values={levelsList!}
                  options={levelOptions}
                  selectAll
                />
              </div>
              {errors && errors?.levels && (
                <p className="text-xs font-medium text-red-400">Please Select one of the Levels</p>
              )}
            </div>
          </div>

          <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
            <p className="w-2/5 text-sm shrink-0">Experience</p>
            <div className="w-full flex flex-col">
              <SelectDropDown
                placeholder="Select Experience"
                value={experience?.toString() || ''}
                options={expOptions.map((i) => i.toString())}
                onChange={(value) => setExperience(value)}
              />
              {errors && errors?.experience && (
                <p className="text-xs font-medium text-red-400">Please Select Experience</p>
              )}
            </div>
          </div>

          <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
            <p className="w-2/5 text-sm shrink-0">Add Strengths</p>
            <div className="w-full flex flex-col">
              <Strengths values={strengths || []} handleChange={setStrengths} icon={CLOSE_ICON} />
              {errors && errors?.strengths && (
                <p className="text-xs font-medium text-red-400">Please Add at least one strength</p>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="w-full flex flex-col">
        {/* <div className="flex items-center justify-between"> */}
        {/* <h3 className="w-1/3 text-sm shrink-0 font-semibold">Add a Type?</h3>
          <div className="w-full h-full flex">
            <div className="flex items-center gap-2">
              <RadioButton
                checked={isType}
                onChange={(x) => x === "on" && setIsType(true)}
                value="yes"
                name="radio-buttons"
                label="Yes"
              />
              <RadioButton
                checked={!isType}
                onChange={(x) => x === "on" && setIsType(false)}
                value="no"
                name="radio-buttons"
                label="No"
              />
            </div>
          </div>
        </div> */}
        {isType && errors && errors?.types && (
          <p className="text-xs font-medium text-red-400">Please Add at least one Type</p>
        )}
      </div>

      {isType && (
        <>
          <CurrentTypeForm category={category} handleTypeChange={handleTypeChange} typeOptions={typeOptions} />
          <div className="flex flex-col gap-2">
            {types.map((type, index) => (
              <HobbyTypeItem
                category={category}
                type={type}
                typeOptions={typeOptions}
                handleTypeChange={handleTypeChange}
                index={index + 1}
                key={index}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

function CurrentTypeForm({
  category,
  handleTypeChange,
  typeOptions
}: {
  category: 'hobby' | 'skill';
  typeOptions: any;
  handleTypeChange: (newValues: IProfessionHobbyType, index?: number) => void;
}) {
  const [currentHobbyType, setCurrentHobbyType] = useState<IProfessionHobbyType>({
    name: '',
    levels: [],
    strengths: [],
    experience: ""
  });

  const [errors, setErrors] = useState<HobbyTypeFormeErrors>();
  const [showNewForm, setShowNewForm] = useState<boolean>(false);

  return (
    <div className={`w-full flex flex-col ${showNewForm && 'border border-gray-300 bg-neutralGray4 p-4'} rounded-md`}>
      <div className="w-full flex items-start justify-between gap-4">
        {showNewForm && (
          <HobbyTypeForm
            category={category}
            name={currentHobbyType.name}
            setName={(value) => setCurrentHobbyType({ ...currentHobbyType, name: value })}
            typeOptions={typeOptions}
            levels={currentHobbyType.levels}
            setLevelsList={(list: ILevels[]) => setCurrentHobbyType({ ...currentHobbyType, levels: list })}
            experience={currentHobbyType.experience}
            setExperience={(value) => setCurrentHobbyType({ ...currentHobbyType, experience: value })}
            strengths={currentHobbyType.strengths}
            setStrengths={(values) => setCurrentHobbyType({ ...currentHobbyType, strengths: values })}
            errors={errors}
          />
        )}
        <div className="max-w-xs">
          {showNewForm ? (
            <div
              className="cursor-pointer"
              onClick={() => {
                setShowNewForm(false);
                setCurrentHobbyType({
                  name: '',
                  levels: [],
                  experience: "",
                  strengths: []
                });

                setErrors(undefined);
              }}
            >
              <img
                src={CLOSE_ICON}
                onClick={() => {
                  setShowNewForm(false);
                  setCurrentHobbyType({
                    name: '',
                    levels: [],
                    experience: "",
                    strengths: []
                  });
                  setErrors(undefined);
                }}
              />
            </div>
          ) : (
            <Button
              text="+ Add Type"
              onClick={() => {
                setShowNewForm(true);
              }}
            />
          )}
        </div>
      </div>
      {showNewForm && (
        <div className="max-w-[164px] mx-auto mt-5 flex items-center justify-end">
          <Button
            block
            text="Add"
            onClick={() => {
              if (
                !currentHobbyType.name ||
                !currentHobbyType.levels.length ||
                currentHobbyType.strengths.length == 0 ||
                !currentHobbyType.experience
              ) {
                setErrors({
                  ...errors,
                  name: !currentHobbyType.name,
                  levels: currentHobbyType.levels.length === 0,
                  strengths: currentHobbyType.strengths.length === 0,
                  experience: !currentHobbyType.experience
                });
                return;
              }
              setErrors(undefined);
              handleTypeChange(currentHobbyType);
              setCurrentHobbyType({
                name: '',
                levels: [],
                experience: "",
                strengths: []
              });
              setShowNewForm(false);
            }}
          />
        </div>
      )}
    </div>
  );
}

function HobbyTypeItem({
  category,
  type,
  typeOptions,
  handleTypeChange,
  index
}: {
  category: 'hobby' | 'skill';
  type: IProfessionHobbyType;
  typeOptions: any[];
  handleTypeChange: (newValues: IProfessionHobbyType, index?: number, remove?: number) => void;
  index: number;
}) {
  const [name, setName] = useState(type.name || '');
  const [levelsList, setLevelsList] = useState(type.levels || []);
  const [experience, setExperience] = useState(type.experience || "");
  const [strengths, setStrengths] = useState(type.strengths || []);

  useEffect(() => {
    if (index) {
      handleTypeChange(
        {
          name,
          levels: levelsList,
          experience,
          strengths
        },
        index
      );
    } else {
      handleTypeChange({
        name,
        levels: levelsList,
        experience,
        strengths
      });
    }
  }, [name, levelsList]);
  return (
    <div className="flex flex-col bg-neutralGray4 p-4 border rounded-md items-start gap-4">
      <img
        src={CLOSE_ICON}
        className="w-3 cursor-pointer flex ml-auto"
        onClick={() => handleTypeChange(type, index, 1)}
      />
      <HobbyTypeForm
        category={category}
        name={name}
        typeOptions={typeOptions}
        setName={(value) => setName(value)}
        levels={levelsList}
        setLevelsList={(list) => setLevelsList(list)}
        experience={experience}
        setExperience={(value) => setExperience(value)}
        strengths={strengths}
        setStrengths={(list) => setStrengths(list)}
      />
    </div>
  );
}

interface HobbyTypeFormeErrors {
  name?: boolean;
  levels?: boolean;
  strengths?: boolean;
  experience?: boolean;
}

interface HobbyTypeFormProps {
  category: 'hobby' | 'skill';
  name: string;
  levels: ILevels[];
  typeOptions: any[];
  setName: (value: string) => void;
  setLevelsList: (list: ILevels[]) => void;
  experience: string;
  setExperience: (value: string) => void;
  strengths: string[];
  setStrengths: (list: string[]) => void;
  errors?: HobbyTypeFormeErrors;
}

function HobbyTypeForm({
  category,
  name,
  levels,
  typeOptions,
  setName,
  setLevelsList,
  experience,
  setExperience,
  strengths,
  setStrengths,
  errors
}: HobbyTypeFormProps) {
  const [levelOptions, setLevelOptions] = useState<any[]>([]);

  useEffect(() => {
    typeOptions?.forEach((t) => {
      if (t.name === name) {
        setLevelOptions(t.levels);
      }
    });
  }, [name, typeOptions]);
  return (
    <div className="w-full flex flex-col gap-7">
      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-1/3 text-sm font-medium shrink-0">Type</h3>
        <SelectDropDown
          placeholder={`Select ${capitalizeFirstLetter(category)}`}
          onChange={(value) => setName(value)}
          options={typeOptions?.map((t) => t.name)}
          value={name}
          isSearchable
        />
        {errors && errors?.name && <p className="text-xs font-medium text-red-400">Please Select Name</p>}
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-1/3 text-sm font-medium shrink-0">Levels</h3>
        <div className="w-full h-full">
          <MultiSelectDropDown
            placeholder="Add Levels"
            onChange={(values: any) => setLevelsList(values)}
            values={levels!}
            options={levelOptions}
            selectAll
          />
          {errors && errors?.levels && <p className="text-xs font-medium text-red-400">Please Select Levels</p>}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <p className="w-1/3 text-sm shrink-0">Experience</p>
        <div className="w-full flex flex-col">
          <SelectDropDown
            placeholder="Select Experience"
            value={experience?.toString() || ''}
            options={expOptions.map((i) => i.toString())}
            onChange={(value) => setExperience(value)}
          />
          {errors && errors?.experience && <p className="text-xs font-medium text-red-400">Please Select Experience</p>}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <p className="w-1/3 text-sm shrink-0">Add Strengths</p>
        <div className="w-full flex flex-col">
          <Strengths values={strengths} handleChange={setStrengths} icon={CLOSE_ICON} />
          {errors && errors?.strengths && (
            <p className="text-xs font-medium text-red-400">Please Add at least one strength</p>
          )}
        </div>
      </div>
    </div>
  );
}
